import React from 'react';
import { Lines, Planets, Cube, Ripple } from 'react-preloaders2';
import { Helmet } from 'react-helmet'
import axios from "axios";
import TriangleAnimated from "../blocks/triangle/TriangleAnimated";
import PagePreloader from "../helpers/PagePreloader";
import config from '../config';


class Imprint extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      session: false,
      images: null,
      content: null
    };

  }

  componentDidMount() {

    var component = this;


    if(!this.state.session) {
      const result =  axios(
        config.backendBase + 'session/token',
      );

      component.setState({
        session: result.data,
      });


      axios({
        method: 'GET',
        url: config.backendBase + 'jsonapi/node/page/a0f963d1-f34b-4f9c-af4f-e0693348ca3c',
        headers: {
          'Content-Type': 'json',
          'X-CSRF-Token': this.state.session,
        }
      })
        .then(res => {

          component.setState({
            content: res.data.data,
            images: res.data.included,
            loading: false,
          });

        })
        .catch(err => {
          //console.log(err);
          component.setState({
            loading: false,
          });
        });
    }

  }


  render() {
    return (
      <React.Fragment>

        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>

        <div className="inner-wrapper">
        <section id="imprint" className="container page">

          <TriangleAnimated right />
          <TriangleAnimated left />
          <TriangleAnimated right bottom />
          <TriangleAnimated left bottom />

          {this.state.loading &&
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          }

          {!this.state.loading &&
            <>
            <h1>Impressum</h1>
            <div dangerouslySetInnerHTML={{ __html: this.state.content.attributes.body.value }} />
            </>
          }

        </section>
        </div>


        <PagePreloader page={this} />

      </React.Fragment>
    );
  }
}


export default Imprint;
